import { $t } from '@/i18n';
import { get } from 'lodash';
import exportExcel, { exportExcels, getFieldsArray } from '@utils/export-excel';
import importExcel from '@utils/import-excel';
import { useFileDialog } from '@vueuse/core';
import { XyExcelFieldConfigMeta, XyExcelEditMeta } from '../paramsFormComponents';
import logger from '@/utils/logger';
import { CATEGORY } from './const';
import { exportCsv } from '@/utils/export-csv';
// Excel导出
export const exportExcelAtom = {
    id: 'xy:exportExcel',
    name: $t('k_6809e9d5'),
    desc: $t('k_9f36607a'),
    category: CATEGORY.EXPORT,
    paramsSchema: {
        type: 'object',
        ui: {
            type: 'XyExcelEdit',
        },
        fields: [
            {
                id: 'jsCode',
                type: 'string',
                title: $t('k_6eb123be'),
                description: $t('k_ca1c0520'),
                ui: {
                    type: 'exprInput',
                    props: {
                        type: 'javascript',
                        multipleLine: true,
                        placeholder: $t('k_ca1c0520'),
                    },
                },
            },
            {
                id: 'mode',
                type: 'array',
                title: $t('k_e9e9695c'),
                default: 'form',
            },
            {
                id: 'fieldConfig',
                type: 'array',
                title: $t('k_e1e11a10'),
                default: [],
                // ui: {
                //   type: 'XyExcelFieldConfigEdit',
                // },
            },
            {
                id: 'fieldConfigJsCode',
                type: 'string',
                title: $t('k_b5f10368'),
                default: '',
            },
            {
                id: 'fileName',
                type: 'string',
                title: $t('k_760abed2'),
                default: 'excel',
            },
            {
                id: 'sheetName',
                type: 'string',
                title: $t('k_2a4f2a'),
                default: 'Sheet1',
            },
            {
                id: 'format',
                title: $t('k_1faa8471'),
                type: 'string',
                enum: [
                    { label: 'xlsx', value: 'xlsx' },
                    { label: 'xlsm', value: 'xlsm' },
                    { label: 'csv', value: 'csv' },
                ],
                default: 'xlsx',
            },
        ],
    },
    paramsFormComponents: [XyExcelFieldConfigMeta, XyExcelEditMeta],
    async execute(ctx, params) {
        const { type = 'single', sheetJsCode, jsCode, fileName, sheetName, format, fieldConfig, mode, fieldConfigJsCode } = params;
        const rtx = get(ctx, 'renderer')?.wContext?.user?.rtx || '';
        if (type === 'multiple') {
            if (format === 'csv') {
                throw new Error($t('k_fb41e1e5'));
            }
            const sheets = ctx.tryEval(sheetJsCode);
            await exportExcels(sheets, {
                author: rtx,
                fileName,
                format,
            }, () => {
                logger.info($t('k_4aa39d46'));
            });
            return;
        }
        const data = ctx.tryEval(jsCode);
        if (!Array.isArray(data)) {
            throw new Error($t('k_a969fe1b'));
        }
        let fields = [];
        if (mode === 'js') {
            fields = ctx.tryEval(fieldConfigJsCode);
        }
        else {
            // 老数据是空的，兼容
            fields = fieldConfig;
        }
        if (!fields?.length) {
            throw new Error($t('k_1dfb1e37'));
        }
        try {
            if (format === 'csv') {
                const newData = getFieldsArray(data, fields);
                await exportCsv(newData, { columns: fields.map(item => item.colName), fileName: `${fileName}.csv` });
            }
            else {
                await exportExcel(data, {
                    author: rtx,
                    fileName,
                    sheetName,
                    format,
                    fields,
                }, () => {
                    logger.info($t('k_4aa39d46'));
                });
            }
        }
        catch (e) {
            throw new Error($t('k_efdf84fc', { arg_0: e.message }));
        }
    },
};
// Excel导入
export const importExcelAtom = {
    id: 'xy:importExcel',
    name: $t('k_1f3cd2f4'),
    desc: $t('k_70ddc8ae'),
    category: CATEGORY.EXPORT,
    paramsSchema: {
        type: 'object',
        fields: [
            {
                id: 'raw',
                type: 'boolean',
                title: $t('k_6cb362be'),
                default: false,
            },
            {
                id: 'cellDates',
                type: 'boolean',
                title: $t('k_69bc32'),
                default: true,
            },
            {
                id: 'codepage',
                type: 'string',
                title: $t('k_8f182987'),
                enum: [
                    {
                        label: $t('k_ef5d61e6'),
                        value: '',
                    },
                    {
                        label: 'UTF-8',
                        value: '65001',
                    },
                    {
                        label: 'GBK / GB2312',
                        value: '936',
                    },
                ],
                default: '',
            },
        ],
    },
    execute: async (ctx, params) => {
        const { raw = false, cellDates = true, codepage } = params;
        const result = await new Promise((rs, rj) => {
            const { open, onCancel, onChange } = useFileDialog({
                accept: '.xlsx, .xls, .csv',
            });
            onChange((files) => {
                if (!files?.length)
                    rs(null);
                const [file] = files;
                if (ctx?.state)
                    ctx.state.__file__ = file;
                const reader = new FileReader();
                reader.onload = async (e) => {
                    try {
                        const data = e?.target?.result;
                        const option = { raw, cellDates };
                        if (codepage)
                            option.codepage = parseInt(codepage, 10);
                        const excelData = await importExcel(data, option);
                        rs(excelData);
                    }
                    catch (e) {
                        rj(e);
                    }
                };
                reader.onerror = (e) => {
                    rj(e);
                };
                reader.readAsBinaryString(file);
            });
            onCancel(() => rs(null));
            open();
        });
        return result;
    },
    returnValue: {
        type: 'object',
        fields: [{
                id: '[filename]',
                type: 'array',
                description: $t('k_2867ff28'),
                items: {
                    type: 'any',
                    description: $t('k_f26bf591'),
                },
            }],
        description: $t('k_c1d887b4'),
    },
};
export default [
    exportExcelAtom,
    importExcelAtom,
];
